import CancelablePromise from "../../functions/CancelablePromise";
import HttpService from "../../infra/http/AxiosConfig";

export const getSalesMan = () =>
  CancelablePromise(HttpService.AxiosClient.get("vendedores/status"));

export const getQuantityGroupedByStatus = (date) =>
  HttpService.AxiosClient.get(`pedidos/quantitativoporStatus/${date.toJSON()}`);

export const getOrdersByStatus = (date) =>
  new Promise((res, rej) =>
    HttpService.AxiosClient.get(`pedidos/detalhadosporstatus/${date.toJSON()}`)
      .then((result) =>
        res({
          solicitado: result.solicitado,
          emAndamento: result.emAndamento,
          concluido: result.concluido,
        })
      )
      .catch((error) => rej(error))
  );
